<template>
   <div :id="id" v-click-outside="hide" v-bind:class="[{ small: type === 'sm' }, 'select']">
      <div class="cursor-pointer" @click='toggle'>
         <div v-bind:class="[{ open: isOpen }, 'toggler']">
            <slot name="prefix">
            </slot>
            <div v-if="inlineLabel" class="float-left mx-4">
               {{ inlineLabel }}
            </div>
            <div class="toggler-label">
               <div v-if="selectedOption">
                  <img v-if="selectedOption.thumbnail" class="option-thumbnail-small"
                       :src="fileResourceUrl(selectedOption.thumbnail)"
                       alt="image"/>&nbsp;
                  {{ selectedOption.text }}
                  <span v-if="selectedOption.nos" class="icon-nos icon"></span>
                  <span v-if="selectedOption.showOekoTex" class="icon-oeko-tex icon"></span>
               </div>
               <div v-else>
                  {{ label }}
               </div>
            </div>
         </div>

         <transition name="fade">
            <div class="select-options" id="selectOptions" v-show="isOpen">
               <slot name="list">
                  <b-list-group>
                     <b-list-group-item :key="option.value" button
                                        v-bind:class="{ active: option.value === value}"
                                        @click="onSelect(option)"
                                        v-for="(option) in options">
                        <img v-if="option.thumbnail" class="option-thumbnail"
                             :src="fileResourceUrl(option.thumbnail)"
                             alt="image"/>&nbsp;
                        {{ option.text }}
                        <span v-if="option.nos"
                              v-bind:class="[option.value === value ? 'icon-nos-inverted' : 'icon-nos', 'icon']"></span>
                        <span v-if="option.showOekoTex" class="icon-oeko-tex icon"></span>
                     </b-list-group-item>
                  </b-list-group>
               </slot>
            </div>
         </transition>
      </div>
   </div>
</template>

<script>
export default {
   name: 'CustomSelect',
   title: {
      type: String,
      required: true
   },
   props: {
      options: {type: Array},
      id: {type: String},
      value: {},
      label: {type: String},
      type: {type: String},
      inlineLabel: {type: String}
   },
   data() {
      return {
         isOpen: false
      }
   },
   methods: {
      onSelect(option) {
         this.$emit('select', option.value);
      },
      hide() {
         this.isOpen = false;
      },
      toggle() {

         this.isOpen = !this.isOpen;

         this.$nextTick(() => {
            if (this.isOpen) {
               let container = this.$el.querySelector('#selectOptions'),
                   selectedItem = container.querySelector('.active');

               if (selectedItem) {
                  container.scrollTop = (selectedItem.offsetTop - 100);
               }
            }
         });

      }
   },
   computed: {
      selectedOption: function () {
         return (this.options && this.options.length >= 0) ? this.options.find(o => o.value === this.value) : null;
      }
   }
}

</script>

<style lang="scss" scoped>

@import "~@shared/_assets/scss/constants";

.select {
   position: relative;

   .option-thumbnail {
      width: 35px;
      height: 35px;
      object-fit: contain;
      margin: auto;
   }

   .option-thumbnail-small {
      width: 20px;
      height: 20px;
      object-fit: contain;
      margin: auto;
   }

   .select-options {
      position: absolute;
      z-index: 999;
      background: white;
      max-width: 400px;
      min-width: 100%;
      box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.3);
      overflow-y: auto;
      max-height: 385px;
   }

   .list-group {
      text-align: center;

      button {
         border: 0;
         border-radius: 0;
         font-size: 15px;
         letter-spacing: 0.5px;
         line-height: 24px;
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
      }
   }

   .toggler {
      padding: 20px;
      min-height: 40px;
      color: $color-primary;
      font-size: 13px;
      letter-spacing: 1.3px;
      line-height: 16px;
      position: relative;
      text-align: center;

      .toggler-label {
         border-right: 20px solid transparent;

         > div {
            color: #8F8F8F;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
         }
      }

      &:after {
         right: 20px;
         background-image: url("~@shared/_assets/svg/angle-down-light.svg");
         width: 28px;
         display: inline-block;
         vertical-align: middle;
         height: 28px;
         content: " ";
         position: absolute;
         background-repeat: no-repeat;
         background-position: 50% 50%;
         top: 50%;
         margin-top: -14px;
      }

      &.open:after {
         background-image: url("~@shared/_assets/svg/angle-up-light.svg");
      }
   }

   .icon {
      padding-right: 10px;
   }
   &.small {
      border: 0;
      background: white;
      height: 46px;

      .icon {
         float: right;
      }
      .toggler {
         text-align: left;
         padding: 12px;
         line-height: 20px;
         &:after {
            right: 10px;
            background-image: url("~@shared/_assets/svg/angle-down-light-sm.svg");
            margin-top: -10px;
            height: 20px;
         }

         &.open:after {
            background-image: url("~@shared/_assets/svg/angle-up-light-sm.svg");
         }
      }

      .list-group {
         text-align: left;
      }
   }
}
</style>